
import { BrowserRouter, Routes, Route } from "react-router-dom"; 
import Home from'./Pages/Home'  
import Smc from'./Pages/Smc'
import ErpSoftware from'./Pages/ErpSoftware'  
import Events from'./Pages/Events'  
import Gallery from'./Pages/Gallery'  
import PrincipalMessage from'./Pages/PrincipalMessage'  
import SubGallery from'./Pages/SubGallery'    
import News from'./Pages/News'  
import Tc from'./Pages/Tc'  
import VideoGallery from'./Pages/VideoGallery' 
import MailUs from'./Pages/MailUs'  
import AboutUs from'./Pages/AboutUs'
import AcademicCalendar from'./Pages/AcademicCalendar'
import Academics from'./Pages/Academics'
import AdmissionWithdrawals from'./Pages/AdmissionWithdrawals'
import AffiliationSelfDeclaration from'./Pages/AffiliationSelfDeclaration'
import AffiliationCertificate from'./Pages/AffiliationCertificate'
import Aims from'./Pages/Aims'
import BuildingSafetyCertificate from'./Pages/BuildingSafetyCertificate'
import CampusInformation from'./Pages/CampusInformation'
import Discipline from'./Pages/Discipline'
import EvaluationScholarships from'./Pages/EvaluationScholarships'
import FeeStructure from'./Pages/FeeStructure'
import FireSafetyCertificate from'./Pages/FireSafetyCertificate'
import GeneralInformation from'./Pages/GeneralInformation'
import HealthSanitationCertificate from'./Pages/HealthSanitationCertificate'
import JuniorWing from'./Pages/JuniorWing'
import KidsCorner from'./Pages/KidsCorner'
import ManagingCommittee from'./Pages/ManagingCommittee'
import VoiceSMS from'./Pages/VoiceSMS'
import Noc from'./Pages/Noc'
import OurPhilosophy from'./Pages/OurPhilosophy'
import OurPrinciples from'./Pages/OurPrinciples'
import PTAMembers from'./Pages/PTAMembers'
import RecognitionCertificate from'./Pages/RecognitionCertificate'
import RegistrationCertificate from'./Pages/RegistrationCertificate'
import ResultAnalysis from'./Pages/ResultAnalysis'
import SchoolFeeStructure from'./Pages/SchoolFeeStructure'
import TeachingStaff from'./Pages/TeachingStaff'  
import SeniorWing from'./Pages/SeniorWing'
import SchoolStrength from'./Pages/SchoolStrength'
import SchoolLeavingCertificate from'./Pages/SchoolLeavingCertificate'
import SchoolInfrastructure from'./Pages/SchoolInfrastructure'
import ManagerMessage from'./Pages/ManagerMessage'
import HeadBoyMessage from'./Pages/HeadBoyMessage'
import HeadGirlMessage from'./Pages/HeadGirlMessage'
import Minority from'./Pages/Minority'
import SpecialFeatures from'./Pages/SpecialFeatures'
import MediaGallery from'./Pages/MediaGallery'
import TopperX from'./Pages/TopperX'
import TopperXII from'./Pages/TopperXII'
import OurAchievements from'./Pages/OurAchievements'
import Infrastructure from'./Pages/Infrastructure'
import HomeWork from'./Pages/HomeWork'
import Circular from'./Pages/Circular'
import Datesheet from'./Pages/Datesheet'
import StaffList from'./Pages/StaffList'
import SchoolCabinet from'./Pages/SchoolCabinet'
import Syllabus from'./Pages/Syllabus'
import SchoolInformation from'./Pages/SchoolInformation'
import VirtualTour from'./Pages/VirtualTour'
import GuestBook from'./Pages/GuestBook'
import PortalHelp from'./Pages/PortalHelp'
import Career from'./Pages/Career'
import SiteMap from'./Pages/SiteMap' 
function App() { 
  return (
      <>
      <BrowserRouter>
      <Routes>
      <Route path="/" element={<Home/>} /> 
      <Route path="/ErpSoftware" element={<ErpSoftware/>} /> 
      <Route path="/Events" element={<Events/>} /> 
      <Route path="/Gallery" element={<Gallery/>} /> 
      <Route path="/News" element={<News/>} /> 
      <Route path="/PrincipalMessage" element={<PrincipalMessage/>} /> 
      <Route path="/SubGallery" element={<SubGallery/>} />  
      <Route path="/Tc" element={<Tc/>} /> 
       <Route path="/VideoGallery" element={<VideoGallery/>} /> 
       <Route path="/MailUs" element={<MailUs/>} />  
       <Route path="/AboutUs" element={<AboutUs/>} />
        <Route path="/AcademicCalendar" element={<AcademicCalendar/>} />
        <Route path="/Academics" element={<Academics/>} />
        <Route path="/AdmissionWithdrawals" element={<AdmissionWithdrawals/>} />
        <Route path="/AffiliationSelfDeclaration" element={<AffiliationSelfDeclaration/>} />
        <Route path="/AffiliationCertificate" element={<AffiliationCertificate/>} />
        <Route path="/Aims" element={<Aims/>} />
        <Route path="/BuildingSafetyCertificate" element={<BuildingSafetyCertificate/>} />
        <Route path="/CampusInformation" element={<CampusInformation/>} />
        <Route path="/Discipline" element={<Discipline/>} />
        <Route path="/EvaluationScholarships" element={<EvaluationScholarships/>} />
        <Route path="/FeeStructure" element={<FeeStructure/>} />
        <Route path="/FireSafetyCertificate" element={<FireSafetyCertificate/>} />
        <Route path="/GeneralInformation" element={<GeneralInformation/>} />
        <Route path="/HealthSanitationCertificate" element={<HealthSanitationCertificate/>} />
        <Route path="/JuniorWing" element={<JuniorWing/>} />
        <Route path="/KidsCorner" element={<KidsCorner/>} />
        <Route path="/ManagingCommittee" element={<ManagingCommittee/>} />
        <Route path="/VoiceSMS" element={<VoiceSMS/>} />
        <Route path="/Noc" element={<Noc/>} />
        <Route path="/OurPhilosophy" element={<OurPhilosophy/>} />
        <Route path="/OurPrinciples" element={<OurPrinciples/>} />
        <Route path="/PTAMembers" element={<PTAMembers/>} />
        <Route path="/RecognitionCertificate" element={<RecognitionCertificate/>} />
        <Route path="/RegistrationCertificate" element={<RegistrationCertificate/>} />
        <Route path="/ResultAnalysis" element={<ResultAnalysis/>} />
        <Route path="/SchoolFeeStructure" element={<SchoolFeeStructure/>} />
        <Route path="/TeachingStaff" element={<TeachingStaff/>} />
        <Route path="/Smc" element={<Smc/>} />
        <Route path="/SeniorWing" element={<SeniorWing/>} />
        <Route path="/SchoolStrength" element={<SchoolStrength/>} />
        <Route path="/SchoolLeavingCertificate" element={<SchoolLeavingCertificate/>} />
        <Route path="/SchoolInfrastructure" element={<SchoolInfrastructure/>} />
        <Route path="/ManagerMessage" element={<ManagerMessage/>} />
        <Route path="/HeadBoyMessage" element={<HeadBoyMessage/>} />
        <Route path="/HeadGirlMessage" element={<HeadGirlMessage/>} />
        <Route path="/Minority" element={<Minority/>} />
        <Route path="/SpecialFeatures" element={<SpecialFeatures/>} />
        <Route path="/MediaGallery" element={<MediaGallery/>} />
        <Route path="/TopperX" element={<TopperX/>} />
        <Route path="/TopperXII" element={<TopperXII/>} />
        <Route path="/OurAchievements" element={<OurAchievements/>} />
         <Route path="/Infrastructure" element={<Infrastructure/>} />
         <Route path="/HomeWork" element={<HomeWork/>} />
         <Route path="/Circular" element={<Circular/>} />
         <Route path="/Datesheet" element={<Datesheet/>} />
         <Route path="/StaffList" element={<StaffList/>} />
         <Route path="/SchoolCabinet" element={<SchoolCabinet/>} />
         <Route path="/Syllabus" element={<Syllabus/>} />
         <Route path="/SchoolInformation" element={<SchoolInformation/>} />
         <Route path="/VirtualTour" element={<VirtualTour/>} />
         <Route path="/GuestBook" element={<GuestBook/>} />
          <Route path="/PortalHelp" element={<PortalHelp/>} />
          <Route path="/Career" element={<Career/>} />
          <Route path="/SiteMap" element={<SiteMap/>} /> 
      </Routes> 
     </BrowserRouter>
      </>
  )
}

export default App;
